// import { axios } from "vue/types/umd";

export default {
    namespaced: true,
  
    state: () => ({
      project: {},
      project_type: {},
      projects: [],
      project_report: {},
      loader:false,
    }),
  
    getters: {
      projects(state) {
        return state.projects;
      },
      project_report(state) {
        return state.project_report;
      },
      project(state) {
        return state.project;
      },
      project_type(state) {
        return state.project_type;
      },
  
    },
  
    mutations: {
      populateProjects(state,newProject){
        state.projects = newProject;
      },
      populateProject(state,newPro){
        state.project = newPro;
      },
      populateProjectReport(state,newReport){
        state.project_report = newReport;
      },
      populateProjectType(state,newProtype){
        state.project_type = newProtype;
      },
      LOADER(state,payload){
        state.loader = payload
      },
    },
  
    actions: {
      getProjectlist({commit},apiArg) {
          // let isSuccess = false
          return new Promise((resolve, reject) => {
          let url = "";
            if(apiArg.type == "work"){
                url = 'project/area/'
            }
            else if (apiArg.type == "sdg"){
                url = 'project/sdg/'
            }
            else{
                url = 'project/region/'
            }
            axios.get(url+apiArg.id)
          .then(res => {
            resolve(res);
          // isSuccess = res.data.data
            commit("populateProjects",res.data.data);
            // return isSuccess;
          // })
          // .catch((error) => {
          //   isSuccess = false
          // });
          // return isSuccess;
        })
        .catch((error) => {
          reject(error);
        });
      });
      },
      getProjectReport({commit}) {
          return new Promise((resolve, reject) => {
            axios.get('sum-all-results')
          .then(res => {
            resolve(res);
            commit("populateProjectReport",res.data.data);
        })
        .catch((error) => {
          reject(error);
        });
      });
      },
      getProjecttypeinfo({commit},apiArg) {
          // let isSuccess = false
          return new Promise((resolve, reject) => {
          let url = "";
            if(apiArg.type == "work"){
                url = 'area/'
            }
            else if (apiArg.type == "sdg"){
                url = 'sdg/'
            }
            else{
                url = 'country/'
            }
            axios.get(url+apiArg.id)
          .then(res => {
            resolve(res);
          // isSuccess = res.data.data
            commit("populateProjectType",res.data.data);
            // return isSuccess;
          // })
          // .catch((error) => {
          //   isSuccess = false
          // });
          // return isSuccess;
        })
        .catch((error) => {
          reject(error);
        });
      });
      },
      getProject({commit},apiArg) {
        commit('LOADER',true)
        return new Promise((resolve, reject) => {
          axios.get('project/'+apiArg)
      .then(res => {
          resolve(res);
            commit("populateProject",res.data.data);
            commit('LOADER',false)
      })
          .catch((error) => {
            reject(error);
            commit('LOADER',false)
          });
      });
      },
    }
  };
  